import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import * as myGlobal from './globals';


@Injectable({
  providedIn: 'root'
})

export class ResizeService {

  get onResize$(): Observable<myGlobal.SCREEN_SIZE> {
    return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
  }

  private resizeSubject: Subject<myGlobal.SCREEN_SIZE>;

  constructor() {
    this.resizeSubject = new Subject();
  }

  onResize(size: myGlobal.SCREEN_SIZE) {
    this.resizeSubject.next(size);
  }
}
